import { BarChart3, Bot, Zap } from 'lucide-react'
import React from 'react'

type Props = {}

const AiFeature = (props: Props) => {
  return (
    <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm mb-6">
              <Bot className="w-4 h-4" />
              <span>AI Intelligence</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Powered by Advanced AI
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-sm">
              <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center mb-6">
                <Zap className="w-6 h-6 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Smart Routing
              </h3>
              <p className="text-gray-600">
                AI automatically routes messages to the most effective channel
                based on customer preferences and engagement history
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm">
              <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center mb-6">
                <Bot className="w-6 h-6 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Automated Responses
              </h3>
              <p className="text-gray-600">
                Intelligent chatbots handle common queries, schedule
                appointments, and escalate complex issues to human agents
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm">
              <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center mb-6">
                <BarChart3 className="w-6 h-6 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Predictive Analytics
              </h3>
              <p className="text-gray-600">
                Get insights into customer behavior, optimal send times, and
                channel performance to maximize engagement
              </p>
            </div>
          </div>
        </div>
      </section>
  )
}

export default AiFeature